import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { P } from '@hrms/shared';
import { useAuth } from '../../../auth/AuthProvider';
import { api } from '../../../lib/api';
import { useGo } from '../../../navigation/nav';
import { OrgChart } from '../../hr/components/OrgChart';
import { Card, EmptyState, ErrorState, Loading, PageHeader, Screen } from '../../../ui';

/** Org chart rooted at the signed-in manager. */
export function ReporteeOrgChartScreen() {
  const { me, can } = useAuth();
  const go = useGo();
  const root = me?.employee?.id;
  const q = useQuery({ queryKey: ['org-chart', root], queryFn: () => api.org.chart(root), enabled: !!root });
  return (
    <Screen refreshing={q.isRefetching} onRefresh={() => q.refetch()} testID="reportee-org-chart">
      <PageHeader title="My org chart" subtitle="Your reportees, direct and indirect." />
      {!root ? (
        <Card><EmptyState icon="user" title="No employee profile linked to your user" /></Card>
      ) : q.isLoading ? (
        <Loading />
      ) : q.isError ? (
        <ErrorState error={q.error} onRetry={() => q.refetch()} />
      ) : !q.data?.length ? (
        <Card><EmptyState icon="sitemap" title="No reportees yet" /></Card>
      ) : (
        <OrgChart roots={q.data} initialDepth={3} onSelect={can(P.EMPLOYEES_VIEW, P.EMPLOYEES_MANAGE) ? (id) => go('EmployeeDetail', { id }) : undefined} />
      )}
    </Screen>
  );
}
